import { Button, ButtonsGroup, Typo } from "#/atoms";
import { FC, memo, useCallback } from "react";

import { ConfirmProps } from "./Confirm.interface";
import { DESKTOP_SPACING } from "@/theme";
import { Modal } from "#/molecules";

const Confirm: FC<ConfirmProps> = ({ description, onClose, onConfirm, showCancel, title, width }) => {
  const handleConfirm = useCallback(() => {
    onConfirm();
    onClose();
  }, []);

  return (
    <Modal onClose={onClose} title={title} width={width}>
      <Typo>{description}</Typo>
      <ButtonsGroup fullWidth margin={`${DESKTOP_SPACING.EL}px 0 0`}>
        {showCancel && <Button buttonColor="primary" actionType="outline" onClick={onClose}>Cancel</Button>}
        <Button onClick={handleConfirm}>Confirm</Button>
      </ButtonsGroup>
    </Modal>
  );
};

export default memo(Confirm);